import React, { useEffect, useState } from 'react';

// Shows toast() messages (utils/toast.js) as banners that drop from the top.
// Several can show at once, newest at the bottom. Each leaves after a while, or
// on a click. Errors stay longer, because they are the ones that need reading.
const LIFE = { ok: 5000, warn: 8000, error: 10000 };
const LOOK = {
  ok: { bg: '#1e8449', icon: '✓' },
  warn: { bg: '#b9601a', icon: '!' },
  error: { bg: '#c0392b', icon: '✕' },
};

export default function Toaster() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const onToast = (e) => {
      const t = e.detail;
      setItems(list => [...list.slice(-3), t]);
      setTimeout(() => setItems(list => list.filter(x => x.id !== t.id)), LIFE[t.kind] || LIFE.ok);
    };
    window.addEventListener('spinboard-toast', onToast);
    return () => window.removeEventListener('spinboard-toast', onToast);
  }, []);
  if (!items.length) return null;
  return (
    <div style={{ position: 'fixed', top: 14, left: '50%', transform: 'translateX(-50%)', zIndex: 10050, display: 'grid', gap: 8, width: 'min(520px, calc(100vw - 32px))', pointerEvents: 'none' }}>
      <style>{'@keyframes sbToastIn{from{opacity:0;transform:translateY(-14px)}to{opacity:1;transform:none}}'}</style>
      {items.map(t => {
        const look = LOOK[t.kind] || LOOK.ok;
        return (
          <div key={t.id} role={t.kind === 'error' ? 'alert' : 'status'} onClick={() => setItems(list => list.filter(x => x.id !== t.id))}
            style={{ pointerEvents: 'auto', cursor: 'pointer', display: 'flex', gap: 10, alignItems: 'center', background: look.bg, color: '#fff', borderRadius: 10, padding: '11px 14px', fontSize: 14, fontWeight: 600, lineHeight: 1.4, boxShadow: '0 10px 30px rgba(0,0,0,0.25)', animation: 'sbToastIn .25s ease-out both', fontFamily: 'inherit' }}>
            <span style={{ width: 22, height: 22, borderRadius: '50%', background: 'rgba(255,255,255,0.22)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, flexShrink: 0 }}>{look.icon}</span>
            <span>{t.message}</span>
          </div>
        );
      })}
    </div>
  );
}
